import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import { Paper, Typography, Box } from '@mui/material';

// Registramos los componentes necesarios para un gráfico de torta
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const StatsChart = ({ chartData, title }) => {
  const data = {
    labels: chartData.map(item => Object.values(item)[0]), // Toma el primer valor (estatus o tipo)
    datasets: [
      {
        label: '# de Solicitudes',
        data: chartData.map(item => item.count), // Toma el conteo
        backgroundColor: [
          'rgba(34, 43, 86, 0.8)',
          'rgba(91, 102, 138, 0.8)',
          'rgba(137, 142, 163, 0.8)',
          'rgba(246, 227, 121, 0.9)',
          'rgba(170, 170, 170, 0.8)',
          'rgba(90, 120, 180, 0.8)',
        ],
        borderColor: [
          'rgba(34, 43, 86, 1)',
          'rgba(91, 102, 138, 1)',
          'rgba(137, 142, 163, 1)',
          'rgba(246, 227, 121, 1)',
          'rgba(170, 170, 170, 1)',
          'rgba(90, 120, 180, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false, // El título lo pondremos fuera del gráfico
      },
    },
  };

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" align="center" gutterBottom>{title}</Typography>
      <Box sx={{ p: 1 }}>
         <Pie data={data} options={options} />
      </Box>
    </Paper>
  );
};

export default StatsChart;